import { VStack, Card, CardBody, CardHeader, Text } from '@cad-arc';
import { DexFormSectionView } from '@mark43/cad-api';
import { DexFormRow } from './dex-form-row';

export function DexFormSection({
    section,
    testId,
    autoFocusField,
}: {
    section: DexFormSectionView;
    testId?: string;
    autoFocusField?: string;
}): React.ReactElement {
    return (
        <Card style={{ width: '100%' }} data-testid={testId}>
            {section.title ? (
                <CardHeader>
                    <Text variant="headingXs">{section.title}</Text>
                </CardHeader>
            ) : undefined}
            <CardBody>
                <VStack gap="4px" align="left">
                    {section.rows.map((fields, i) => (
                        <DexFormRow fields={fields} key={i} autoFocusField={autoFocusField} />
                    ))}
                </VStack>
            </CardBody>
        </Card>
    );
}
